import React, { useEffect } from 'react';
import Header from './components/Header/Header';
import Services from './components/Services/Services';
import About from './components/About/About';
import Portfolio from './components/Portfolio/Portfolio';
import Contact from './components/Contact/Contact';
import BackToTopButton from './components/Common/BackToTopButton';
import smoothscroll from 'smoothscroll-polyfill';
import './App.css';

smoothscroll.polyfill();

function App() {
  useEffect(() => {
    const cursor = document.createElement('div');
    const cursorDot = document.createElement('div');
    cursor.className = 'custom-cursor';
    cursorDot.className = 'cursor-dot';
    document.body.appendChild(cursor);
    document.body.appendChild(cursorDot);

    // Move cursor
    const moveCursor = (e) => {
      cursor.style.left = `${e.clientX}px`;
      cursor.style.top = `${e.clientY}px`;
      cursorDot.style.left = `${e.clientX}px`;
      cursorDot.style.top = `${e.clientY}px`;
    };

    // Click effect
    const clickEffect = () => {
      cursor.classList.add('clicked');
      setTimeout(() => {
        cursor.classList.remove('clicked');
      }, 100);
    };

    // Hover detection
    const handleHover = (e) => {
      const target = e.target;
      cursor.classList.remove('button-hover', 'text-hover');
      
      if (target.tagName === 'BUTTON' || target.tagName === 'A' || target.classList.contains('btn')) {
        cursor.classList.add('button-hover');
      } 
      else if (['H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'P'].includes(target.tagName)) {
        cursor.classList.add('text-hover');
      }
    };

    document.addEventListener('mousemove', moveCursor);
    document.addEventListener('mousedown', clickEffect);
    document.addEventListener('mouseover', handleHover);

    // Cleanup
    return () => {
      document.removeEventListener('mousemove', moveCursor);
      document.removeEventListener('mousedown', clickEffect);
      document.removeEventListener('mouseover', handleHover);
      if (cursor.parentNode) document.body.removeChild(cursor);
      if (cursorDot.parentNode) document.body.removeChild(cursorDot);
    };
  }, []);

  return (
    <div className="App">
      <Header />
      <main>
        <section id="services"><Services /></section>
        <section id="about"><About /></section>
        <section id="portfolio"><Portfolio /></section>
        <section id="contact"><Contact /></section>
      </main>
      <BackToTopButton />
    </div>
  );
}

export default App;